// import { useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { Navigate, Route, Routes, useLocation } from "react-router-dom";
// import Header from "../components/header/Header";
// import MainLoader from "../components/loading/MainLoader";
// import Sidebar from "../components/sidebar/Sidebar";
// import routes, { IRouteItemProps } from "../const/routes";
// import { IPrivilege } from "../interfaces/privilege";
// import Unauthorized from "../pages/unauthorized/Unauthorized";
// import { getPrivileges } from "../store/actions/auth.action";
// import { IRootState } from "../store/configureStore";
// import hasPrivilege from "../util/hasPermission";
// import Box from "@mui/material/Box";

// const PrivateLayout = () => {
//   const location = useLocation();
//   const dispatch = useDispatch();

//   const {
//     isAuthenticated,
//     isAuthLoading,
//     privileges,
//     profile,
//     isLoadingPrivileges,
//   } = useSelector(({ auth, privileges }: IRootState) => ({
//     isAuthenticated: auth.loggedIn,
//     isAuthLoading: auth.loading,
//     privileges: privileges.dataBundle,
//     profile: privileges.dataBundleUser,
//     isLoadingPrivileges: privileges.loading,
//   }));

//   useEffect(() => {
//     if (isAuthenticated && privileges.length === 0) {
//       dispatch(getPrivileges());
//     }
//   }, [isAuthenticated, privileges, dispatch, profile]);

//   const getRouteList = (
//     items: IRouteItemProps[],
//     privileges: IPrivilege[] | undefined
//   ): JSX.Element[] => {
//     return items.map((item, index) => {
//       if (hasPrivilege(privileges, item.id)) {
//         return <Route key={index} path={item.route} element={item.element} />;
//       }

//       return <Route key={index} path={item.route} element={<Unauthorized />} />;
//     });
//   };

//   if (!isAuthenticated) {
//     return <Navigate to="/" state={{ from: location }} />;
//   }

//   if (isAuthLoading || isLoadingPrivileges) {
//     return <MainLoader show />;
//   }

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         width: "100%",
//         height: "100vh",
//         overflow: "hidden",
//       }}
//     >
//       <Box
//         sx={{
//           flex: 1,
//           background: `linear-gradient(to left,rgb(229, 243, 255),rgb(222, 238, 252))`,
//           display: { xs: "none", sm: "block" },
//         }}
//       >
//         {/* Left column */}
//         <Sidebar />
//       </Box>
//       <Box
//         sx={{
//           flex: 4,
//           display: "flex",
//           flexDirection: "column",
//           // background: `linear-gradient(to bottom, rgb(223, 238, 252) 50%, rgb(3, 86, 161) 50%)`,
//         }}
//       >
//         {/* Right column with two rows */}
//         <Box
//           sx={{
//             display: { xs: "none", sm: "block" },
//           }}
//         >
//           <Header />
//         </Box>
//         {/*
//         <Box
//           sx={{
//             borderRadius: "0 30px 0 30px",
//             background: "white",
//             overflowY: "auto",
//             height: "calc(100vh)",

//             "&::-webkit-scrollbar": {
//               width: "5px",
//               height: "8px",
//             },
//             "&::-webkit-scrollbar-track": {
//               background: "#f1f1f1",
//             },
//             "&::-webkit-scrollbar-thumb": {
//               background: "rgb(3, 86, 161)",
//               borderRadius: "10px",
//             },
//             "&::-webkit-scrollbar-thumb:hover": {
//               background: "#555",
//             },
//           }}
//         > */}
//         <Box
//           sx={{
//             borderRadius: "30px 30px 0 0",
//             margin: { xs: "80px 0 0 0", sm: "50px 50px 0 50px" },
//             boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
//             background: "white",

//             overflowY: "auto",
//             height: "calc(100vh)",

//             "&::-webkit-scrollbar": {
//               width: "5px",
//               height: "8px",
//             },
//             "&::-webkit-scrollbar-track": {
//               background: "#f1f1f1",
//             },
//             "&::-webkit-scrollbar-thumb": {
//               background: "rgb(3, 86, 161)",
//               borderRadius: "10px",
//             },
//             "&::-webkit-scrollbar-thumb:hover": {
//               background: "#555",
//             },
//           }}
//         >
//           <Routes>
//             {routes(location).map((item) =>
//               getRouteList(item.subItems, profile?.role.privileges)
//             )}
//           </Routes>
//         </Box>
//       </Box>
//       {/* </Box> */}
//     </Box>
//   );
// };

// export default PrivateLayout;
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Header from "../components/header/Header";
import MainLoader from "../components/loading/MainLoader";
import Sidebar from "../components/sidebar/Sidebar";
import routes, { IRouteItemProps } from "../const/routes";
import { IPrivilege } from "../interfaces/privilege";
import Unauthorized from "../pages/unauthorized/Unauthorized";
import { getPrivileges } from "../store/actions/auth.action";
import { IRootState } from "../store/configureStore";
import hasPrivilege from "../util/hasPermission";
import Box from "@mui/material/Box";

const PrivateLayout = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const {
    isAuthenticated,
    isAuthLoading,
    privileges,
    profile,
    isLoadingPrivileges,
  } = useSelector(({ auth, privileges }: IRootState) => ({
    isAuthenticated: auth.loggedIn,
    isAuthLoading: auth.loading,
    privileges: privileges.dataBundle,
    profile: privileges.dataBundleUser,
    isLoadingPrivileges: privileges.loading,
  }));

  useEffect(() => {
    if (isAuthenticated && privileges.length === 0) {
      dispatch(getPrivileges());
    }
  }, [isAuthenticated, privileges, dispatch, profile]);

  const getRouteList = (
    items: IRouteItemProps[],
    privileges: IPrivilege[] | undefined
  ): JSX.Element[] => {
    return items.map((item, index) => {
      if (hasPrivilege(privileges, item.id)) {
        return <Route key={index} path={item.route} element={item.element} />;
      }

      return <Route key={index} path={item.route} element={<Unauthorized />} />;
    });
  };

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} />;
  }

  if (isAuthLoading || isLoadingPrivileges) {
    return <MainLoader show />;
  }

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "minmax(200px, 1fr) 4fr",
        width: "100%",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {/* Left column - Sidebar */}
      <Box
        sx={{
          background: `linear-gradient(to left,rgb(229, 243, 255),rgb(222, 238, 252))`,
          display: { xs: "none", sm: "block" },
        }}
      >
        <Sidebar />
      </Box>

      {/* Right column */}
      <Box
        sx={{
          display: "grid",
          gridTemplateRows: "auto 1fr",
          height: "100vh",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: { xs: "none", sm: "block" },
          }}
        >
          <Header />
        </Box>

        {/* Content area */}
        <Box
          sx={{
            borderRadius: "30px 30px 0 0",
            margin: { xs: "80px 0 0 0", sm: "10px 10px 0 10px" },
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)",
            background: "white",
            overflowY: "auto",

            "&::-webkit-scrollbar": {
              width: "5px",
              height: "8px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
              marginTop: "20px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "rgb(3, 86, 161)",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#555",
            },
          }}
        >
          <Routes>
            {routes(location).map((item) =>
              getRouteList(item.subItems, privileges)
            )}
          </Routes>
        </Box>
      </Box>
    </Box>
  );
};

export default PrivateLayout;
